import $ from 'jquery';
import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);


$(function () {
    window.initSlider();
});


/**
 * Slider container element
 */
window.initSlider = function ($object = null) {


    if (null === $object) {
        $object = $('.slider')
    } else if (!$($object).is('slider')) {
        $object = $($object).find('.slider')
    }

    $object.each(function () {
        const $container = $(this).find('.swiper');
        const $prev = $(this).find('.swiper-button-prev');
        const $next = $(this).find('.swiper-button-next');
        const $pagination = $(this).find('.swiper-pagination');

        const $toggleArrows = $container.find($('.slider-item-toggle-text'));
        const $toggleContents = $container.find($('.slider-item-text'));


        $toggleContents.addClass('hidden');

        $toggleArrows.on('click', function () {
            $toggleArrows.toggleClass('opened');
            $toggleContents.toggleClass('hidden');
        });

        let dataLoop = false;
        if ($container.data('loop') && true === $container.data('loop')) {
            dataLoop = true;
        }

        let centeredSlides = false;
        if ($container.data('centered') && true === $container.data('centered')) {
            centeredSlides = true;
        }
        let breakpoints = {
            [window.gridBreakpoints.lg]: {
                slidesPerView: 3,
            },
            [window.gridBreakpoints.sm]: {
                slidesPerView: 2,
            },
            [window.gridBreakpoints.xs]: {
                slidesPerView: 1,
            }};
        let slidesPerView=3;
        if ($container.data('singleslider') && true === $container.data('singleslider')) {
            
            breakpoints={}
            slidesPerView=1;
        }

        new Swiper($container[0], {
            direction: 'horizontal',
            loop: dataLoop,
            // autoplay: {
            // 	delay: 5000,
            // },
            speed: 600,
            slidesPerView: slidesPerView,
            centeredSlides: centeredSlides,
            spaceBetween: 32,
            autoHeight: false,
            wrapperClass: 'slider-wrapper',
            slideClass: 'slide',
            containerModifierClass: 'slider-container-',
            navigation: {
                prevEl: $prev[0],
                nextEl: $next[0],
            },
            breakpoints: breakpoints,
            pagination: {
                el: $pagination[0],
                clickable: true,
                type: 'bullets',
            },

        });
    });

};
